// **********************************************************
// Card Slider
// **********************************************************

const cardSlider = document.querySelectorAll('[data-slider="card-slider"]');

const cardSliderOptions = {
  slidesPerView: 1,
  centeredSlides: true,
  allowTouchMove: true,
  spaceBetween: 0,
  speed: 600,
  loop: true,
  loopAdditionalSlides: 2,
  preventInteractionOnTransition: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    stopOnLastSlide: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2.5,
      allowTouchMove: true,
    },
    1023: {
      slidesPerView: 3,
      allowTouchMove: true,
    },
    1200: {
      slidesPerView: 3.5,
      allowTouchMove: false,
    },
    1439: {
      slidesPerView: 4,
      allowTouchMove: false,
    },
  },
};

const sliderAltOptions = () => {
  if (windowWidth() < 1200) {
    cardSliderOptions.effect = 'creative';
    cardSliderOptions.creativeEffect = {
      limitProgress: 4,
      prev: {
        translate: ['-110%', '36px', 0],
        rotate: [0, 0, -12],
        scale: 1,
        origin: 'bottom',
      },
      next: {
        translate: ['110%', '36px', 0],
        rotate: [0, 0, 12],
        scale: 1,
        origin: 'bottom',
      },
    };
  }
};

sliderAltOptions();
window.addEventListener('resize', sliderAltOptions);

cardSlider.forEach((el) => {
  const cardSliderEle = el.closest('.card-slider');
  const arrowRight = cardSliderEle.querySelector('.swiper-button-next');
  const arrowLeft = cardSliderEle.querySelector('.swiper-button-prev');
  const cardSliderInit = cardSliderEle.querySelector('.card-slider__init');

  cardSliderOptions.navigation.nextEl = arrowRight;
  cardSliderOptions.navigation.prevEl = arrowLeft;

  const cardSwiper = new Swiper(el, cardSliderOptions);

  attachEvent('[data-modal-trigger]', 'click', (ev) => {
    cardSwiper.autoplay.pause();
    ev.preventDefault();
  });

  attachEvent('[data-close-modal]', 'click', (ev) => {
    cardSwiper.autoplay.resume();
    ev.preventDefault();
  });

  setTimeout(() => {
    el.classList.add('is-init');
  }, 10);

  // **********************************************************

  const swiperObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          cardSwiper.autoplay.start();
        } else {
          cardSwiper.autoplay.stop();
        }
      });
    },
    { threshold: 0.7 },
  );

  swiperObserver.observe(cardSliderInit);

  // **********************************************************

  const updateSlideClasses = (startElement, direction) => {
    let currentElement = startElement;

    const classSuffixes = ['first', 'second', 'third'];
    classSuffixes.forEach((suffix) => {
      currentElement =
        direction === 'next' ? currentElement?.nextElementSibling : currentElement?.previousElementSibling;

      const className = `${suffix}-${direction}`;
      cardSliderEle.querySelector(`.${className}`)?.classList.remove(className);
      currentElement?.classList.add(className);
    });
  };

  const updateSlides = () => {
    const swiperSlideNext = cardSliderEle.querySelector('.swiper-slide-next');
    const swiperSlidePrev = cardSliderEle.querySelector('.swiper-slide-prev');

    updateSlideClasses(swiperSlideNext, 'next');
    updateSlideClasses(swiperSlidePrev, 'prev');
  };

  updateSlides();

  cardSwiper.on('slideChangeTransitionStart', () => {
    updateSlides();
  });
});

// **********************************************************
// Card Slider Animations
// **********************************************************

const cardSliderImages = document.querySelectorAll('.card-slider__bg img');

cardSliderImages.forEach((image) => {
  gsap.to(image, {
    y: '20%',
    scrollTrigger: {
      trigger: image,
      start: '20% 80%',
      end: 'bottom top',
      scrub: true,
    },
  });
});
